<template>
<div >
   
    <div class="esign">
        <div class="esign-box">
            <vue-esign id='esignId' class="sign1"  ref="esign" :width="1"  :height="1"  :isCrop="isCrop"  :lineWidth="lineWidth" :lineColor="lineColor"  :bgColor.sync="bgColor"  />
            <div style="float:right;padding-top:20px;font-size:20px" >微信<br>扫一<br>扫,<br>关注<br>公众<br>号</div>
           <div style='float:right'> <img    style="width:200px;height:200px"   src="../assets/公众号二维码.jpg" ></div>
         
        </div>
          <div style="float:left;padding-top:20px;font-size:20px" >  微信<br>扫一<br>扫,<br>在线<br>同步<br>签名</div>
          <div ><vue-qr   ref= 'qrId' :text="text" :size="200"></vue-qr></div>
          <div style="float:left;padding-top:20px;font-size:20px ;border:1px solid red;width: 440px;height:180px;margin-left:-10px;margin-top:18px" > 
              <img  id="conf0"  style="width:100%;height:100%" :hidden="resultImg==''"   :src="resultImg" >
          </div>
      </div>
    
    <br>
     <div style="float:right;padding-left:10px;font-size:20px;width:400px"><span style='color:red'> 注意：</span>
      请在微信扫码签名前关注 
       微信公众号，点击【我的】-
       【客户注册】进行注册，确认
       签名有效性，同时签名后可在
       公众号【委托管理】【进度查询】查询委托进度
       </div>
     <div style="float:right;margin-top:45px">
        <el-button type="primary" @click="handleGenerate">&emsp;确认签名&emsp;</el-button><br><br>
     </div>
     <br><br> <br><br> <br><br> <br><br> <br><br> <br>
  </div>
</template>
<script>

import { RequestGet, getImageName ,updateFIle} from '../api/api';
 
import VueQr from 'vue-qr'
export default {
components:{VueQr},
props: {
    token: {
      type: String,
      default: ''
    },
    imgDialog: {
      type: Boolean,
      default: false
    }
  },
watch : {
    imgDialog:function(val) {
        if(val===true){
          this.startPolling()
          this.handleReset()
        }else{
          this.stopPolling();
        }
    },  
},
created:function(){
   this.startPolling();
   this.handleReset()
},

data() {
  return {
    lineWidth: 6,
    lineColor: "#000000",
    bgColor: "",
    resultImg: "",
    openId: "",
    isCrop: false,
    borders: "1px solid red",
    text :  "https://fw.ceprei.com/service/wx/consignSignRedirect.do?token="+this.token,
    myInterval:null,
  };
},
 
methods: {
  
    startPolling () {
        this.myInterval = window.setInterval(() => {
          setTimeout(() => {
              if(this.imgDialog!== true){
                this.stopPolling();
              }
              this.getbast64()
            }, 1)
          }, 1000);
    },
  
    stopPolling  () {
      clearInterval( this.myInterval)
      this.myInterval = null;
    },
    handleReset() {
      this.$refs.esign.reset();
    },
    creatimg() {
      this.$refs.esign.generate() .then((res) => {
          this.resultImg = res;
          this.stopPolling()
        }).catch((err) => {
            this.$alert('没有签名,请签名',{dangerouslyUseHTMLString: true,showCancelButton:true,lockScroll:false})
        });
    },
    getbast64(){
         getImageName('https://fw.ceprei.com/service/app/sign/getSign',{'token':this.token}).then(response => {
					var obj=response['data'];
					if(!(obj===undefined||obj===''||obj===null)){
            this.resultImg = obj.base64Img;
            this.openId=obj.openId;
            console.log("this.openId=" + this.openId);
            // this.stopPolling();
					}
				}).catch(error => {
			  	console.log(error+'微信获取签名失败', '请求错误');
				})
    },
    handleGenerate() {
      this.$refs.esign.generate() .then((res) => {
          this.resultImg = res;
          this.stopPolling()
          this.getImgr() ;
        }).catch((err) => {
          if(this.resultImg===''){
            this.$alert('没有签名,请签名',{dangerouslyUseHTMLString: true,showCancelButton:true,lockScroll:false})
          }else{
            this.getImgr()
            this.stopPolling()
          }
        });
         
    },
    getImgr(){
      let file = this.dataURLtoFile(this.resultImg ) 
      let formData = new FormData()
      formData.append('file', file)
      updateFIle('https://fw.ceprei.com/service/image/save',formData).then(response => {
        this.resultImg = '';
        this.$emit('callback', {imgUrl:response,openId:this.openId} )
      }).catch(error => {
			  	console.log(error+'微信获取签名失败', '请求错误');
			})
    },


  dataURLtoFile(dataurl) {//将base64转换为文件
      var  filename='lsdkfjalkejl.png';
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
  },
   
 
},
}
</script>

<style scoped>
.esign {
  max-width: 1200px;
  margin: auto;
  padding: 10px;
  /* height: 250px; */
  border: 1px solid rebeccapurple;
}
.esigh-btns button {
  color: #fff;
  height: 40px;
  width: 100px;
  font-size: 16px;
  margin-right: 10px;
  outline: none;
  border-radius: 4px;
  background: #f60;
  border: 1px solid transparent;
}
.esigh-btns button:active {
  color: #fff;
  box-shadow: 0px 0px 50px orangered inset;
}
.esigh-result {
  margin-top: 10px;
}
.esigh-result img {
  display: block;
  /* max-width: 100%; */
  /* height: auto; */
  max-width: 50%;
  height: 50%;
  margin: auto;
  left: 50%;
  transform: rotateX(50%);
  border: 1px solid #ececee;
}
.esignature {
  margin: 10px 0;
  border: 2px solid #ccc;
}
</style>


// WEBPACK FOOTER //
// esign.vue?4cf88733